// FormCompanyQuerys.tsx
export const ERROR_EMPTY_QUERY = "Requête vide"; 
export const ERROR_UNKNOW_QUERY_FILTER = "Critere inconnu"; 
export const ERROR_EMPTY_ELEMENT = "Non Vide"; 
export const ERROR_QUERY_ALREADY_WRITE = "Requete déjà renseigné !"; 
export const ERROR_INCORRECT_QUERY = "Un des champs est incorrecte "; 